const FETCH_LIST_SUCCESS = "jangl/verticals/FETCH_LIST_SUCCESS";

export { FETCH_LIST_SUCCESS };
